<template>
  <label class="input"
         :lang="isNumber ? 'uk-US' : null"
         :class="selector">
    <div v-if="label" class="input__label">
      <span>{{ label }}
        <span v-if="sub" class="input__label-sub">{{ sub }}</span>
        <span v-if="isAttributeTrue($attrs.required)"
              class="input__required"> *</span>
      </span>
      <BaseTooltip
        v-if="tooltipText"
        :text="tooltipText"
        class="d-inline"
        tooltip-menu-style="max-width: 24rem"
      >
        <template v-slot:activator>
          <div class="input__tooltip-activator">?</div>
        </template>
      </BaseTooltip>
    </div>
    <textarea v-if="textarea"
              v-bind="$attrs"
              ref="input"
              @change="onChange($event)"
              @input="onInput($event)"
              @focus="onFocus()"
              @blur="onBlur()"
              :value="value"
              :style="style"
              class="input__input"></textarea>

    <input v-else-if="mask"
           v-mask="mask"
           v-bind="$attrs"
           ref="input"
           @change="onChange($event)"
           @input="onInput($event)"
           @focus="onFocus()"
           @blur="onBlur()"
           :value="value"
           :style="style"
           class="input__input">

    <input v-else
           v-bind="$attrs"
           ref="input"
           @change="onChange($event)"
           @input="onInput($event)"
           @blur="onBlur()"
           :value="value"
           :style="style"
           class="input__input">

    <InputError :value="error"/>
  </label>
</template>

<script>
  import InputError from './BaseInputError'

  export default {
    inheritAttrs: false,
    components: {
      InputError
    },
    props: {
      value: {
        type: [Number, String],
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      sub: {
        type: String,
        default: ''
      },
      textarea: {
        type: Boolean,
        default: false
      },
      overTitle: {
        type: Boolean,
        default: true
      },
      leftSpace: Number,
      error: {
        type: [String, Array]
      },
      mask: {
        type: [String, Function]
      },
      regexp: {
        type: RegExp,
      },
      autofocus: {
        type: Boolean,
        default: false,
      },
      tooltipText: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        focus: false,
        isVisiblePassword: false
      }
    },
    computed: {
      isPassword() {
        return this.$attrs.type === 'password'
      },
      isNumber() {
        return this.$attrs.type === 'number'
      },
      filled() {
        return !!this.value || Number.isFinite(this.value)
      },
      selector() {
        let selector = ''
        if (this.overTitle) selector += ' _over '
        if (this.focus) selector += ' _focus '
        if (this.filled) selector += ' _filled '
        if (this.error) selector += ' _error '
        if (this.isPassword) selector += ' _password '
        if (this.$attrs.disabled) selector += ' _disabled '
        return selector
      },
      style() {
        let s = {}

        if (this.leftSpace) {
          s.paddingLeft = (1.7 + this.leftSpace) + 'rem'
        }

        return s
      }
    },
    mounted() {
      if (this.autofocus) this.$refs.input.focus();
    },
    methods: {
      onChange(event) {
        this.$emit('change', this.formatValue(event.target.value))
      },
      onFocus() {
        this.focus = true
        this.$emit('focus');
      },
      onBlur() {
        this.$refs['input'].value = this.value
        this.focus = false
        this.$emit('blur');
      },
      onInput(event) {
        if (this.isNumber && (event.data === '.' || event.data === ',')) return
        this.$emit('input', this.formatValue(event.target.value))
      },
      isAttributeTrue(attr) {
        return attr || attr === ''
      },
      formatValue(receivedValue) {
        let value = receivedValue

        if (this.isNumber && value) {
          value = value.toString().replace(/[^0-9]+/g, '.')
          value = value.replace(',', '.')

          if(isNaN(value)) {
            value = null
          }
        }

        if (this.regexp) {
          if(value === null) {
            value = ''
          }

          value = value.toString()
          value = value.replace(this.regexp, '')
        }

        if(value !== receivedValue) {
          this.$refs['input'].value = value
        }

        return value
      }
    }
  }
</script>

<style lang="less">

</style>
